var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync-parent"},[_vm._v(" 我是父组件: "+_vm._s(_vm.text)+" "),_c('Child',{attrs:{"text":_vm.text},on:{"update:text":function($event){_vm.text=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }